import { ComposedCondition } from "@hyper-inferno/survey-elements-core";

export const OPERATOR_FUNCTIONS: Record<
  string,
  (userVal: any, cond: ComposedCondition) => boolean
> = {
  // --- Choice Logic ---
  // Expects userValue to be a number[] .option_key)
  // Is: checks if the array contains exactly this one key and nothing else
  is: (uv, c) => uv.length === 1 && uv[0] === Number(c.option_key),

  // Is Not: true if the array doesn't contain the key, or contains other things too
  is_not: (uv, c) => !uv.includes(Number(c.option_key)),

  // Expects userValue to be an array of strings .option_keys)
  inc_any: (uv, c) => Array.isArray(uv) && uv.includes(c.option_key),
  inc_all: (uv, c) => {
    // Checks if the user's selected options include all options listed in targets
    if (!Array.isArray(uv) || !c.option_targets) return false;
    return c.option_targets.every((target) => uv.includes(target));
  },
  is_ex: (uv, c) => {
    // Checks if the user's selection is exactly the target set (order-independent)
    if (!Array.isArray(uv) || !c.option_targets) return false;
    return (
      uv.length === c.option_targets.length &&
      uv.every((target) => c.option_targets!.includes(target))
    );
  },

  // --- Text Logic ---
  // Case-insensitive comparisons are usually safer for surveys
  eq_text: (uv, c) =>
    String(uv || '').toLowerCase() ===
    String(JSON.parse(c.value_manual) || '').toLowerCase(),
  cont: (uv, c) =>
    String(uv || '')
      .toLowerCase()
      .includes(String(JSON.parse(c.value_manual) || '').toLowerCase()),
  sw: (uv, c) =>
    String(uv || '')
      .toLowerCase()
      .startsWith(String(JSON.parse(c.value_manual) || '').toLowerCase()),

  // --- Numeric Logic ---
  eq_num: (uv, c) => {
    console.log(uv, c.value_manual, JSON.parse(c.value_manual));
    return Number(uv) === Number(JSON.parse(c.value_manual));
  },
  neq_num: (uv, c) => Number(uv) !== Number(JSON.parse(c.value_manual)),
  gt: (uv, c) => Number(uv) > Number(JSON.parse(c.value_manual)),
  lt: (uv, c) => Number(uv) < Number(JSON.parse(c.value_manual)),
  bet_num: (uv, c) => {
    // Expects value_manual to be an array [min, max] or an object {min, max}
    const val = Number(uv);
    const { min, max } = JSON.parse(c.value_manual) || {};
    return val >= min && val <= max;
  },

  // --- State Logic ---
  ans: (uv) =>
    uv !== undefined &&
    uv !== null &&
    uv !== '' &&
    !(Array.isArray(uv) && uv.length === 0),
  nans: (uv) =>
    uv === undefined ||
    uv === null ||
    uv === '' ||
    (Array.isArray(uv) && uv.length === 0),
};
